module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IPziNU/images/bcover.jpg?1690533387396",
      "alt": "This image is the cover for the book Second Chances"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Second Chances\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A treasury of motivational anecdotes from people who wanted another chance at something good—and took it.")]), _c('br'), _c('br'), _vm._v("The book collects the hopeful examples of people who found a leg up, another spurt of energy, a hidden talent, or even an untapped strength, sometimes with the unexpected help of friends or strangers, to make a happier life for themselves. It’s the big stuff like going back to college after the kids have grown up, as well as the little things like getting a judo belt when you thought you could hardly manage a push-up. "), _c('br'), _c('br'), _vm._v("From the author of "), _c('i', [_vm._v("One Good Deed")]), _vm._v(","), _c('i', [_vm._v(" Like My Mother Always Said")]), _vm._v(", and other entertaining and motivating volumes, this book is an inspiring guide to letting the future win over the past.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Erin McHugh\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Based in New York City, Erin McHugh is a former publishing executive and the author of more than 25 books, including Like My Mother Always Said, Like My Father Always Said, Like My Teacher Always Said, and One Good Deed.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    ABRAMS\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0